export const ConnectorSources: {
	readonly Federated: 'federated';
	readonly Smartlinks: 'smartlinks';
	readonly Lite: 'lite-connector';
	readonly Full: 'full-connector';
	readonly Backfill: 'backfill';
} = {
	Federated: 'federated',
	Smartlinks: 'smartlinks',
	Lite: 'lite-connector',
	Full: 'full-connector',
	Backfill: 'backfill',
} as const;
